'use client';

import { createSafeContext } from './createSafeContext';
interface Variant {
  readonly value?: string;
  readonly payload?: Record<string, unknown>;
}

interface ExperimentClient {
  variant(key: string, fallback?: string | Variant): Variant;
}

interface ExperimentContextValue {
  readonly isReady: boolean;
  readonly client: ExperimentClient | null;
}

const [ExperimentContextProvider, useExperimentContext] =
  createSafeContext<ExperimentContextValue>('ExperimentContext');

export { ExperimentContextProvider, useExperimentContext };
export type { ExperimentClient, ExperimentContextValue, Variant };
